/**
 * Uniform font-run capture/apply, shared by the shape swap (formatOps) and the
 * OOXML duplicate/split (slideOoxml) so the field list and copy logic live in
 * one place. `null`/`undefined` values mean "mixed or unset" and are skipped
 * on apply.
 */

/** Run-level font properties Office.js can read/write (highlight isn't exposed). */
export const FONT_FIELDS = [
  "bold",
  "italic",
  "underline",
  "size",
  "color",
  "name",
  "strikethrough",
  "subscript",
  "superscript",
  "allCaps",
] as const;

export type FontSnapshot = Partial<Record<(typeof FONT_FIELDS)[number], unknown>>;

/** Capture a text range's uniform font properties. */
export function snapshotFont(font: PowerPoint.ShapeFont): FontSnapshot {
  const src = font as unknown as Record<string, unknown>;
  const snap: FontSnapshot = {};
  for (const key of FONT_FIELDS) snap[key] = src[key];
  return snap;
}

/** Apply captured font properties, skipping `null`/`undefined` (mixed/unset). */
export function applyFont(font: PowerPoint.ShapeFont, snap: FontSnapshot): void {
  const dst = font as unknown as Record<string, unknown>;
  for (const key of FONT_FIELDS) {
    const value = snap[key];
    if (value !== null && value !== undefined) dst[key] = value;
  }
}
